export default {
    pressList: {},
};
  
